

















import { useConfigStore } from '@/store/config';
import { defineComponent, computed } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { windowHelper } from '@tencent/ppd-base-libs';
import { GoodDeedDayNewsType } from '@/types';
import { CONF, getMultiLangAttr } from '@/business/act-config';

export default defineComponent({
  name: 'NewsModule',
  components: { },
  setup() {
    const configStore = useConfigStore();
    const { goodDeedDayNews } = storeToRefs(configStore);
    const goodDeedDayNewsVal = computed(() => goodDeedDayNews.value);

    const goToDetail = (news: GoodDeedDayNewsType) => {
      if (news.newsUrl) {
        windowHelper.redirect(news.newsUrl, 300);
      }
    };

    return {
      goodDeedDayNewsVal,
      goToDetail,
      projectInfo: getMultiLangAttr(CONF, 'project_info'),
    };
  },
});
